import React, { useEffect, useRef, useState } from "react";
import { useMusic } from "../../context/MusicContext";
import { useNavigate } from "react-router";

const MusicWrapper = () => {
  const musicContext = useMusic();
  const musicRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (musicRef != null) {
      musicContext.setMusicRef(musicRef);
    }
  }, []);

  useEffect(() => {
    const handleEnded = () => {
      if (musicContext.playlist.length - 1 > musicContext.currentIndex) {
      musicContext.pauseAudio();
      musicContext.reset();
      musicContext.playNextTrack();
      // musicContext.currentIndex(musicContext.data)
      }else{
        musicContext.pauseAudio();
      }
    };

    musicRef.current.addEventListener("ended", handleEnded);

    return () => {
      musicRef.current.removeEventListener("ended", handleEnded);
    };
  }, [musicContext.musicRef, musicContext.playNextTrack]);

  // MusicWrapper.js
  useEffect(() => {
    if (musicContext?.data && musicContext.song?.id) {
      // Find the index of the current audio URL in the playlist
      const currentIndex = musicContext.playlist.findIndex(
        (item) => item.id === musicContext.song.id
      );
      if (currentIndex !== -1 && currentIndex !== musicContext.currentIndex) {
        musicContext.setCurrentIndex(currentIndex);
      }
    }
  }, [musicContext?.data, musicContext.playlist, musicContext.song]);

  useEffect(() => {
    if (musicContext?.song.title != "") {
      if ("mediaSession" in navigator) {
        navigator.mediaSession.metadata = new window.MediaMetadata({
          title: musicContext?.song.title,
          artist: musicContext?.song.artist,
          artwork: [{ src: musicContext?.song.image, sizes: '96x96', type: 'image/png' }],
        });
      }
    }
  }, [musicContext?.song]);

  return (
    <>
      <audio
        ref={musicRef}
        src={musicContext.data}
        // onLoadedMetadata={musicContext.onLoadMeta}
      ></audio>
    </>
  );
};

export default MusicWrapper;
